import React from 'react'
import styled from 'styled-components'
import MobileTile from '@components/Table/Mobile/MobileTile'
import TableHeader from '@components/Table/TableHeader'
import TableRow from '@components/Table/TableRow'
import Loading from '@components/Loading'
import NoResults from '@components/Table/NoResults'
import { Table, TableBody } from 'grommet'

export default ({
    data,
    columns,
    changeOrderBy,
    orderBy,
    ExpandedRowComponent,
    page,
}) => {
    if (!data) {
        return <Loading />
    }

    if (data.length === 0) {
        return <NoResults />
    }

    return (
        <OuterContainer>
            {/* desktop: display = none below 768px */}
            <MainTableWrapper>
                <Table>
                    <TableHeader
                        columns={columns}
                        orderBy={orderBy}
                        changeOrderBy={changeOrderBy}
                    />
                    <StyledTableBody>
                        {data.map((row, r) => {
                            return (
                                <TableRow
                                    key={'table-row' + r}
                                    row={row}
                                    rowIndex={r}
                                    columns={columns}
                                    ExpandedRowComponent={ExpandedRowComponent}
                                    page={page}
                                />
                            )
                        })}
                    </StyledTableBody>
                </Table>
            </MainTableWrapper>

            {/* mobile: display = none above 768px */}
            {data.map((row, r) => {
                return (
                    <MobileTile
                        key={'mobile-tile-row-' + r}
                        row={row}
                        columns={columns}
                        ExpandedRowComponent={ExpandedRowComponent}
                    />
                )
            })}
        </OuterContainer>
    )
}

const MainTableWrapper = styled.div`
    width: 100%;
    display: block;
    margin: 0px auto;
    @media (max-width: 768px) {
        display: none;
    }
`

const OuterContainer = styled.div`
    width: calc(100% - 40px);
    margin: 20px auto;
    overflow-x: auto;
    overflow-y: hidden;
`

const StyledTableBody = styled(TableBody)`
    background-color: #fff;
`
